// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckboxList_wrapper__gsxRp"};